/** @format */

import { Box, Image, Text } from "@chakra-ui/react";
import runes from "runes";
import { validaValidadede } from "../../../utils";
import { BoxVigencia } from "../../CardComponents/BoxVigencia";
import { ButtonAtivaDesconto } from "../../CardComponents/ButtonAtivaDesconto";
import { CardHeader } from "../../CardComponents/CardHeader";
import { Container } from "../../CardComponents/Container";
import { ContentPrice } from "../../CardComponents/ContentPrice";
import { TextValidade } from "../../CardComponents/TextValidade";
import { usePersonalizacao } from "../../../context/usePersonalizacao";
import { Observacao } from "../../CardComponents/Observacao";

export function CardDescontoExclusivoVertical({
  props,
  onClickCard,
  inCaroussel = false,
}) {
  const {
    //HEADER
    id_classificacao_topete,
    idtiporecomendacao,

    //PRODUTO
    idoferta,
    nomeoferta,
    percentualdesconto,
    valorde,
    valorpor,
    observacao,

    //VALIDADE
    limitecompra,
    saldoutilizado,
    validade,
    validadeate,
    validadede,

    //IMAGENS
    imagem,
    selopromocao,
    seloClube,

    //ESTADO
    clube,
    validoapartir = validaValidadede({ validadede: props.validadede }),
    ativado,
    dataativacao,
  } = props;

  const {
    personalizacao: { card },
  } = usePersonalizacao();

  const getCorBgDestaqueSelo = () => {
    if (idtiporecomendacao === "1") {
      return card?.descontoexclusivo?.cordestaque
        ? card?.descontoexclusivo?.cordestaque
        : card?.cordestaque;
    }
    if (idtiporecomendacao === "2") {
      return card?.tabloide?.cordestaque
        ? card?.tabloide?.cordestaque
        : card?.cordestaque;
    }
    if (idtiporecomendacao === "3") {
      return card?.cashback?.cordestaque
        ? card?.cashback?.cordestaque
        : card?.cordestaque;
    }
  };

  return (
    <Container
      props={{
        validoapartir: validoapartir,
        clube: clube,
        inCaroussel: inCaroussel,
        idtiporecomendacao: idtiporecomendacao,
      }}>
      <Box cursor="pointer" onClick={onClickCard}>
        <CardHeader
          props={{
            id_classificacao_topete: id_classificacao_topete,
            validadede: validadede,
            idtiporecomendacao: idtiporecomendacao,
          }}
        />

        <Box padding="0.5rem">
          {/* Image Section */}
          <Box display="flex" flexDir="row" justifyContent="center">
            <Box filter={validoapartir ? "grayscale(1)" : "grayscale(0)"}>
              {selopromocao ? (
                <Box
                  background={clube ? getCorBgDestaqueSelo : "transparent"}
                  marginLeft="-0.5rem"
                  paddingY="0.25rem"
                  paddingX="0.30em"
                  borderTopRightRadius="md"
                  borderBottomRightRadius="md">
                  <Image
                    objectFit="contain"
                    w="40px"
                    h="40px"
                    src={selopromocao}
                  />
                </Box>
              ) : !selopromocao && seloClube ? (
                <Box
                  background={clube ? getCorBgDestaqueSelo : "transparent"}
                  marginLeft="-0.5rem"
                  paddingY="0.25rem"
                  paddingX="0.30em"
                  borderTopRightRadius="md"
                  borderBottomRightRadius="md">
                  <Image
                    objectFit="contain"
                    w="40px"
                    h="40px"
                    src={seloClube}
                  />
                </Box>
              ) : (
                <Box w="40px" h="40px" />
              )}
              <Box filter={validoapartir ? "grayscale(1)" : "grayscale(0)"}>
                {seloClube && selopromocao ? (
                  <Box
                    background={clube ? getCorBgDestaqueSelo : "transparent"}
                    marginLeft="-0.5rem"
                    paddingY="0.25rem"
                    paddingX="0.30em"
                    borderTopRightRadius="md"
                    borderBottomRightRadius="md">
                    <Image
                      objectFit="contain"
                      w="40px"
                      h="40px"
                      src={seloClube}
                    />
                  </Box>
                ) : (
                  <Box w="40px" h="40px" />
                )}
              </Box>
            </Box>
            <Box
              marginX="0.3125rem"
              filter={validoapartir ? "grayscale(1)" : "grayscale(0)"}>
              <Image
                objectFit="contain"
                width="104px"
                height="104px"
                src={imagem}
              />
            </Box>
            <Box width="40px" height="40px" borderRadius="full" />
          </Box>

          {/* ContainerTextProduto */}
          <Box whiteSpace="normal" paddingTop="0.5rem" paddingBottom="0.25rem">
            <Text fontSize="0.75rem" color="#3E4047" fontWeight="black">
              {nomeoferta.length > 25
                ? runes.substr(nomeoferta, 0, 25) + "..."
                : nomeoferta.length <= 25
                ? `${nomeoferta}`
                : nomeoferta}
            </Text>
          </Box>

          {/* ContentPrice */}
          <ContentPrice
            desconto
            props={{
              percentualdesconto: percentualdesconto,
              validadede: validadede,
              valorde: valorde,
              valorpor: valorpor,
            }}
          />

          <TextValidade
            props={{
              validadeate: validadeate,
              validadede: validadede,
              limitecompra: limitecompra,
              validade: validade,
              saldoutilizado: saldoutilizado,
            }}
          />

          <Observacao observacao={observacao} />

          <BoxVigencia
            props={{ validadede: validadede, validoapartir: validoapartir }}
          />
        </Box>
      </Box>

      {/* Button ativa desconto */}
      <ButtonAtivaDesconto
        props={{
          idoferta,
          validadede,
          validadeate,
          ativado,
          dataativacao,
        }}
      />
    </Container>
  );
}
